import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/operator/takeUntil';
import { ClothingDisposition } from '../../../models/clothing-disposition.model';
import { ClothingDispositionService } from '../../../services/clothing-disposition.service';
import { ASSET } from './asset.constants';
import { assetErrorKey, workflowTrackBy } from './asset.helpers';

@Component({selector: 'app-clothing-profile-dispositions', template: `
  <section class="asset-panel clothing-profile-dispositions" *ngIf="loading || errorKey || items.length || hasMore" [attr.aria-busy]="loading">
    <h3>{{ 'CLOTHING_DISPOSITION_PROFILE_TITLE' | translate }}</h3>
    <p *ngIf="loading" role="status">{{ 'ASSET_LOADING' | translate }}</p>
    <p *ngIf="errorKey" role="alert">{{ errorKey | translate }} <button class="btn btn-link" type="button" [disabled]="loading" (click)="load()">{{ 'ASSET_RETRY' | translate }}</button></p>
    <article class="asset-row" *ngFor="let item of items; trackBy: trackBy">
      <button class="btn btn-link asset-name" type="button" [attr.aria-expanded]="selectedId === item.unitId" (click)="select(item)">
        {{ item.catalogItemName || ('CLOTHES' | translate) }}<span *ngIf="item.unitNumber"> · {{ 'CLOTHING_UNIT_NUMBER' | translate }} #{{ item.unitNumber }}</span>
      </button>
      <p class="asset-meta">{{ ('CLOTHING_DISPOSITION_STATUS_' + item.status) | translate }} · {{ item.amountByn }} {{ item.currency }}</p>
      <app-clothing-disposition *ngIf="selectedId === item.unitId" [unitId]="item.unitId" [itemName]="item.catalogItemName" [unitNumber]="item.unitNumber" (changed)="mutated()"></app-clothing-disposition>
    </article>
    <button *ngIf="hasMore" class="btn btn-secondary" type="button" [disabled]="loading" (click)="load(true)">{{ 'ASSET_MORE' | translate }}</button>
  </section>`, styleUrls: ['./employee-assets.component.css']})
export class ClothingProfileDispositionsComponent implements OnChanges, OnDestroy {
  @Input() employeeId: string;
  @Output() changed = new EventEmitter<void>();
  items: ClothingDisposition[] = [];
  trackBy = workflowTrackBy;
  selectedId = ASSET.empty;
  page = ASSET.zero;
  hasMore = false;
  loading = false;
  errorKey = ASSET.empty;
  private generation = ASSET.zero;
  private disposed = false;
  private request: Subscription;
  private destroyed = new Subject<void>();
  constructor(private api: ClothingDispositionService) {}
  ngOnChanges(): void { this.selectedId = ASSET.empty; this.load(); }
  ngOnDestroy(): void { this.disposed = true; this.generation++; this.destroyed.next(); this.destroyed.complete(); }
  select(item: ClothingDisposition): void { this.selectedId = this.selectedId === item.unitId ? ASSET.empty : item.unitId; }
  mutated(): void { this.load(); this.changed.emit(); }
  load(more = false): void {
    if (this.disposed || more && this.loading) { return; }
    if (this.request) { this.request.unsubscribe(); }
    const generation = ++this.generation; const page = more ? this.page + ASSET.one : ASSET.zero;
    if (!more) { this.items = []; this.page = ASSET.zero; this.hasMore = false; }
    this.errorKey = ASSET.empty; this.loading = false;
    if (!this.employeeId) { return; }
    this.loading = true;
    this.request = this.api.list(this.employeeId, page).takeUntil(this.destroyed).subscribe(items => {
      if (!this.current(generation)) { return; }
      this.items = more ? this.items.concat(items) : items;
      this.page = page; this.hasMore = items.length === ASSET.pageSize; this.loading = false;
    }, error => {
      if (!this.current(generation)) { return; }
      this.loading = false;
      if (error && (error.status === ASSET.forbidden || error.status === ASSET.unauthorized)) {
        this.items = []; this.selectedId = ASSET.empty; this.hasMore = false;
      } else { this.errorKey = assetErrorKey(error, false); }
    });
  }
  private current(generation: number): boolean { return !this.disposed && generation === this.generation; }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/employee-assets/clothing-profile-dispositions.component.ts